import React from 'react'
import { TableCell, TableRow } from '@mui/material'
import UserImg from "../../common/assests/sampleuser.svg";
import ReyLeaf from '../../common/assests/reyleafLogo.svg'
import configuration from '../../config/Config';
const UserOrderProductRow = ({row}) => {
  return (
    <TableRow
    key={row?._id}
    sx={{
      "&:last-child td, &:last-child th": { border: 0 },
    }}
  >
    <TableCell>
    <img
    src={
      row?.product?.photos && row?.product?.photos.length > 0
        ? `${configuration.cdnFront}/${row?.product?.photos[0].url}`
        : ReyLeaf
    }
        alt="img"
        style={{
          height: "35px",
          width: "35px",
          marginRight: "8px",
          borderRadius: "10px",
        }}
      />
    </TableCell>
    <TableCell>{row?.product?.title||"-"}</TableCell>
    <TableCell>{row?.product?.categoryId?.name||"-"}</TableCell>
    <TableCell>{row?.quantity||"-"}</TableCell>
    <TableCell>{`$${row?.product?.price||"-"}`}</TableCell>
    <TableCell>{`$${(row?.quantity * (row?.product?.discountedProce || 0)).toFixed(2) || "0.00"}`}</TableCell>
    {/* <TableCell>{`$${orderProducts?.discountedProce||"-"}`}</TableCell> */}
    <TableCell>{`$${row?.product?.discountedProce||"-"}`}</TableCell>
  </TableRow>
  )
}

export default UserOrderProductRow